import '../js/custom.js';

// ios scroll
import '../js/ios-scroll/ios-scroll';

// form
import '../js/form/form';
import '../js/form/mask';
import '../js/form/select';
import '../js/form/images-upload';
import '../js/form/images-sort';
import '../js/form/images-delete';
import '../js/form/image-upload';
import '../js/form/video';
import '../js/form/map';
import '../js/form/ajax';
import '../js/form/repeater';
import '../js/form/type';
import '../js/form/multichecker';
import '../js/form/file';

// search
import '../js/search/search';

// popup
import '../js/popup/popup';

// footer
import '../js/footer/director';

// button-up
import '../js/button-up/button-up';

// realty
import '../js/realty/gallery-slider';